import React, { Component, createContext } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const AuthContext = createContext({
    checked: false,
    user: null,
    uid:null
});

export class AuthContextProvider extends Component {
    state = {
        user: null,
        checked: false,
        uid: null,
    };

    /*
	This will run once, when this component is 
	mounted (at application start).
	*/

    componentDidMount = () => {
        // get current auth state from firebase
        const auth = getAuth();

        /*
		If firebase is initialized and has a user 
		then set the user and mark authentication 
		as "checked"
		*/

        if (auth.currentUser) {
            this.setState({
                user: auth.currentUser,
                checked: true,
                //uid: auth.currentUser.uid,
            });
        }
        /*
		Listen for authentication state changes from firebase.
		Once an authentication state change comes in, we can
		consider authentication to be "checked" so that is set to
		true on each call. 

		Other than that, this will handle if a login or logout
		has been triggered. 
		*/

        onAuthStateChanged(auth, (user) =>
            this.setState({ checked: true, user: user })
        );
    };

    render = () => {
        return (
            <AuthContext.Provider value={this.state}>
                {this.props.children}
            </AuthContext.Provider>
        );
    };
}
